@switch (mode) {
    @case (RecaptchaMode.Copyright) {
        <!-- eslint-disable -->
        <p class="typography-body-small pt-2">
            This site is protected by reCAPTCHA and the Google
            <a target="parent" href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a target="parent" href="https://policies.google.com/terms">Terms of Service</a> apply.
        </p>
        <!-- eslint-enable -->
    }
    @case (RecaptchaMode.Widget) {
        @if (isWidgetVisible) {
            <ngx-invisible-recaptcha
                [siteKey]="reCAPTCHASiteKey"
                [useGlobalDomain]="false"
                (error)="HandleCAPTCHAError($event)"
                (success)="HandleCAPTCHA($event)">
            </ngx-invisible-recaptcha>
        }
    }
}
